export default __webpack_public_path__ + "static/media/engineering.b32033f8.png";